// Web entry point — SeeTex browser version
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "katex/dist/katex.min.css";
import "../src/latex-styles.css";
import "../src/App.css";
import "./web-styles.css";
import { WebApp } from "./App";
import { AutocompleteProvider } from "../src/contexts/AutocompleteContext";
import { AuthProvider } from "./contexts/AuthContext";
import { initializeFirebase } from "./config/firebase";

// Initialize Firebase before rendering
initializeFirebase();

// Dev-only keystroke recorder — available in browser console as _seetexRec
if (import.meta.env.DEV) {
    import("../src/editor/console-recorder").then(({ installConsoleRecorder }) => {
        installConsoleRecorder();
    });
}

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <AuthProvider>
            <AutocompleteProvider>
                <WebApp />
            </AutocompleteProvider>
        </AuthProvider>
    </StrictMode>
);
